import React, { useState, useContext, useEffect } from 'react';
import { Box, Accordion, Grid, Button } from '@mantine/core';
import ContentPaper from '../../../../components/layouts/rfs/Content';
import { Row } from 'react-bootstrap';
import { RfsContext } from '../../../../contexts/RfsContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AppLoader } from '../../../../components/common/loader';
import { SupplierNameTable } from './supplierNameTable';
import { TableExport } from 'tabler-icons-react';
import { CSVLink } from 'react-csv';
import moment from 'moment';
import { ProjectOverviewContext } from '../../../../contexts/projectOverviewContext';
import { roles } from '../../../../constants';
import { AuthContext } from '../../../../contexts/AuthContext';
import { sCodeStyles } from '../../../../utils/helpers';

export default function SupplierNameCode() {
  const { userRole } = useContext(AuthContext);
  const { form } = useContext(RfsContext);
  const { rfs_number } = form.rfsInformation;
  const accessors = {
    materials: 'selection_number',
    liquids: 'selection_number',
    skus: 'selection_number',
  };
  const secondaryAccessor = {
    materials: 'selection_name',
    liquids: 'selection_name',
    skus: 'selection_name',
  };
  const tertiaryAccessor = {
    materials: null,
    liquids: null,
    skus: null,
  };
  const [scopeErrors, setScopeErrors] = useState({
    errors: {},
    liquidErrors: {},
    materialErrors: {},
    productionSiteErrors: {},
  });

  const [loading, setLoading] = useState(false);
  const [supplierName, setSupplierName] = useState([]);
  const [disable, setDisable] = useState(true);
  const { fetchSupplierName } = useContext(RfsContext);
  const { getVendors, vendors } = useContext(ProjectOverviewContext);

  useEffect(() => {
    getData(rfs_number);
    getVendors();
  }, []);

  useEffect(() => {
    if ([roles.admin, roles.superAdmin, roles.pmo, roles.procurement].includes(userRole))
      setDisable(false);
  }, [userRole]);

  const getData = (rfs_number) => {
    setLoading(true);
    fetchSupplierName(rfs_number).then((res) => {
      setSupplierName(res.data.data);
      setLoading(false);
    });
  };

  const handleAltNumberChange = (id, name, value) => {
    let currentValues = [...supplierName];
    const index = currentValues.findIndex((i) => i.id === id);
    currentValues[index]['int_rfs_impl_supplier'][name] = value;
    setSupplierName(currentValues);
  };

  const refresh = (rfs_number) => {
    fetchSupplierName(rfs_number).then((res) => {
      setSupplierName(res.data.data);
    });
  };

  const sort_SN_acctoSKUs = [...supplierName].sort((a, b) => a.scope_id - b.scope_id);

  const selectedScopeFn = (data) => {
    let selectedScopeList = {};
    for (let i = 0; i < data.length; i++) {
      selectedScopeList[data[i].id] = {
        selection_number: data[i].selection_number,
        selection_name: data[i].selection_name,
      };
    }
    return selectedScopeList;
  };

  var selectedScopeList = selectedScopeFn(form.selectedScope.skus);

  const dataToExport = ({
    mat_code,
    mat_desc,
    int_rfs_ps_bom,
    int_rfs_impl_supplier,
    status,
    sla_date,
    scope_id,
    finished_date,
    int_rfs_ps_sku_reference,
    supplier,
  }) => {
    return {
      'SKU no.': selectedScopeList[scope_id]?.selection_number,
      'SKU DESC': selectedScopeList[scope_id]?.selection_name,
      Plant: int_rfs_ps_sku_reference?.selected_plant,
      'Pack Mat Number': mat_code,
      'Pack Mat Description': mat_desc,
      'Existing Suppliers': supplier,
      'Add Supplier': int_rfs_impl_supplier?.add_supplier,
      'New Supplier Number': int_rfs_impl_supplier?.new_supplier_number,
      'New Supplier Name': int_rfs_impl_supplier?.new_supplier_name,
      Status: status,
      'Step deadline': sla_date,
      'Step finished': status === 'Closed' ? finished_date : status,
    };
  };
  const csvArray = sort_SN_acctoSKUs.map(dataToExport);

  if (loading) {
    return (
      <ContentPaper page={'ProductDevelopment'}>
        <AppLoader size='lg' center />
      </ContentPaper>
    );
  }

  return (
    <ContentPaper page={'ProductDevelopment'}>
      <Box sx={sCodeStyles}>SKU CODES</Box>
      <div
        style={{
          display: 'flex',
          justifyContent: 'right',
          marginRight: '4rem',
        }}
      >
        <CSVLink
          data={csvArray}
          filename={'Supplier name_' + moment().format('YYYY-MM-DD HH:mm:ss')}
        >
          <Button leftIcon={<TableExport />} variant='gradient' radius='md' color='green'>
            Export to CSV
          </Button>
        </CSVLink>
      </div>
      <Row>
        <Accordion>
          {Object.keys(form?.selectedScope || {}).map((name) =>
            form?.selectedScope[name].map((item, index) => {
              const supplierList = supplierName?.findIndex((m) => m.scope_id === item.id);
              const plants = Object.values(form.scopeSelectedSkus);
              const uniquePlants = {};
              plants.forEach((p) => {
                if (p.scope_id === item.id && p.active) {
                  if (uniquePlants[p.selected_plant]) {
                    uniquePlants[p.selected_plant].plantIds.push(p.id);
                  } else {
                    uniquePlants[p.selected_plant] = { plantIds: [p.id] };
                  }
                }
              });

              return (
                supplierList > -1 && (
                  <Accordion.Item
                    className='scope-label'
                    key={`key_${name}_${index}`}
                    value={`key_${name}_${index}`}
                  >
                    <Accordion.Control>
                      {`${name.substring(0, 3).toUpperCase()} -  ${item[accessors[name]]}- ${
                        item[secondaryAccessor[name]]
                      }${tertiaryAccessor[name] ? `- ${item[tertiaryAccessor[name]]}` : ''}`}
                    </Accordion.Control>
                    <Accordion.Panel>
                      {Object.keys(uniquePlants).map((plant, index) => {
                        const data = supplierName.filter((d) =>
                          uniquePlants[plant].plantIds.includes(d.int_rfs_ps_sku_reference.id),
                        );

                        return (
                          data.length > 0 && (
                            <Accordion>
                              <Accordion.Item
                                className='scope-label'
                                value={`Plant ${plant}`}
                                key={`key_${name}_${index}`}
                              >
                                <Accordion.Control>{`Plant ${plant}`}</Accordion.Control>
                                <Accordion.Panel>
                                  {
                                    <Grid>
                                      <Grid.Col span={12}>
                                        <SupplierNameTable
                                          supplierData={data}
                                          onChange={handleAltNumberChange}
                                          refresh={refresh}
                                          rfs={rfs_number}
                                          vendors={vendors}
                                          disable={disable}
                                        />
                                      </Grid.Col>
                                    </Grid>
                                  }
                                </Accordion.Panel>
                              </Accordion.Item>
                            </Accordion>
                          )
                        );
                      })}
                    </Accordion.Panel>
                  </Accordion.Item>
                )
              );
            }),
          )}
        </Accordion>
      </Row>
    </ContentPaper>
  );
}
